import React from 'react'
import Navbar from '../Components/Navbar'
import cycle from '../Assets/cycle.png'
import img from '../Assets/ch.png'
import Footer from '../Components/Footer'
function AngelInvesting() {
  return (
  <>
    <Navbar/>
    <div className='banner banner6'>
    <h2 data-aos="fade-right">Angel Investing</h2>
    
    <p data-aos="fade-right">Home / Angel Investing</p>
   
    </div>
    <div className='legendary'>
    <h2 data-aos="fade-right">We help the daring build legendary companies.</h2>
    <br/>
    <br/>
    <div className='legendary-div'>
    <div className='legendary-left'>
<h3>Collaborative.Flexible. Innovative.</h3>
<p>Pioneering venture capital solutions</p>
<h4>We've helped 10+ innovative companies grow and scale their businesses. With a track record of successful exits and an average 10x return on investment, we partner with visionary entrepreneurs to build the next generation of market-leading companies. Our hands-on approach and extensive network provide the resources and expertise needed to accelerate growth and achieve outstanding results.</h4>
</div>
 <div className='legendary-right'>
 <div className='legendary-cards'>
  <div className='no'>01</div>
  <div className='amounts'>
    <h3>10+</h3>
  </div>
  <div className='leg-name'>
    <p>Companies Helped to Grow</p>
  </div>
 </div>
 <br/>
 
 <div className='legendary-cards'>
  <div className='no'>02</div>
  <div className='amounts'>
    <h3>15+</h3>
  </div>
  <div className='leg-name'>
    <p>Successful Exits</p>
  </div>
 </div>
 <br/>
 
 <div className='legendary-cards'>
  <div className='no'>03</div>
  <div className='amounts'>
    <h3>10x</h3>
  </div>
  <div className='leg-name'>
    <p>Average ROI for Investors</p>
  </div>
 </div>
</div>
    </div>

    </div>
    {/* <div className='lifecycle'>
   
    <h3>Complete Platform Across Venture  
    <span> Capital Lifecycle</span></h3>
    <h4>Industry Ventures’ complementary investment strategies allows us to be a partner to fund managers and<br/> entrepreneurs from inception to end of fund life and provides investment exposure from pre-seed to pre-IPO companies.</h4>
<br/>
<br/>
<br/>
<img src={cycle}/>
    </div> */}
    <div className='HIGHLISGHTS'>
    <div className='HIGHLISGHTS-left'>

    {/* <p>HIGHLISGHTS</p> */}
    <h3 data-aos="fade-right">Investment <span>Highlights</span></h3>
    <br/>
    <h4 data-aos="fade-right">
We cultivate relationships with specialized venture capital leaders, enabling access to top companies.*
</h4>

</div>
 <div className='HIGHLISGHTS-right'>
 <img src={img} data-aos="zoom-in"/>

</div>

    </div>
    <div className='Pioneering'>
        <h3 data-aos="zoom-in">Pioneering Since <span>the Beginning</span></h3>
        <br/>
        <p data-aos="zoom-in">Over the last twenty years, the firm has evolved from being a pioneer in secondary investments to becoming the leading provider of flexible capital solutions for the venture ecosystem. We propelled the seed-stage venture market and support our managers’ top companies with additional capital to grow.</p>
    </div>
    <Footer/>
  </>
  )
}

export default AngelInvesting